<template>
    <b-modal :id="$id('existingModal')" :visible="visible" centered no-close-on-backdrop no-close-on-esc :style="generateVariantStyle(Variant)">
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col class="text-left">
                    <h6>{{ SelectedMenuItem.Text }}</h6>
                </b-col>
                <b-col class=" pr-0 p-1 pl-4 text-right">
                    <!-- Close : Fermer -->
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false;" v-b-tooltip.hover :title="$t('Close')" />
                </b-col>
            </b-row>
        </template>

        <b-row>
            <b-col>
                <b-form-radio-group v-model="useExistingEquipment" >
                    <b-form-radio :value=false >{{ $t('NewEquipment')}}</b-form-radio>
                    <b-form-radio :value=true >{{ $t('UseExistingEquipment')}}</b-form-radio>
                </b-form-radio-group>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col>
                <b-form-select v-model="selectedEquipment" size="sm" :disabled="!useExistingEquipment" :options="ExistingEquipments" value-field="Id" text-field="Label" />
            </b-col>
        </b-row>

        <template #modal-footer="{ok,close}">
            <b-row>
                <!-- Cancel : Annuler -->
                <b-button @click="close(); visible = false" :variant="'outline-' + Variant" pill class="mx-1">{{$t('Cancel')}}</b-button>
                <span id="disabledCheck" class="d-inline-block" tabindex="0">
                    <!-- Validate : Valider -->
                    <b-button @click="ok(); manageGhostEquipment(); visible = false;" pill >{{$t('Validate')}}</b-button>
                </span>
            </b-row>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { API_URL, MAIN_FILTER_TREE } from '@/App.settings';
    import Dictionary from '@/types/Dictionary';
    import EnumItem from '@/types/fields/EnumItem';
    import MenuItem from '@/types/MenuItem';
    import axios from 'axios';
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { InjectReactive, Prop, PropSync } from 'vue-property-decorator';
    import { ThemeUtils } from '@/components/commons/Utils';

    // Traductions
    import locales from "./locales/ExistingEquipment.json";
import TreeNode from '@/types/TreeNode';

    @Component({ i18n: { messages: locales }})
    export default class ExistingEquipment extends ThemeUtils {
        /** Variant de couleur à appliquer sur le composant */
        @InjectReactive()
        public Variant!: string;

        @Prop({ default : () => undefined })
        public SelectedMenuItem!: MenuItem; 

        @Prop({ default : () => undefined })
        public ParentNode!: TreeNode;

        /** Permet d'indiquer si la fenêtre est affichée ou non */
        @PropSync('Visible', {default : () => false } )
        public visible!: boolean;

        /** Booléen determinant si on veut créer un nouvel équipement ou se base sur un existant */
        private useExistingEquipment : boolean = false;

        /** Liste des équipements existants */
        @Prop()
        public ExistingEquipments!: EnumItem[];

        /** Equipement existant sélectionnée */
        private selectedEquipment : string = "";

        /** Gestion de l'equipement  */
        private manageGhostEquipment(){
            // Utilisation d'un equipement existant
            if(this.useExistingEquipment){
                console.debug("ExistingEquipment - manageEquipment - selectedEquiqment : %O", this.selectedEquipment);
                this.$store.dispatch("ObjectStore/NewGhostEquipment", { objectType: this.SelectedMenuItem.ObjectType, parentNodeId: this.ParentNode.Id, selectedEquipment: this.selectedEquipment })
                    .then(() => {
                        let node = this.$store.getters[MAIN_FILTER_TREE + "/Node"](this.selectedEquipment);
                        this.$store.dispatch(MAIN_FILTER_TREE +  "/SelectNode", { node: node, openNode: true, scrollIntoView: false });

                        // Affichage d'une popup indiquant que l'objet a été crée
                        this.$bvToast.toast(this.$t('EquipmentRefAdded').toString(), { 
                            title: this.$t('AddEquipment').toString(), // $t('AddBusinessObject') / Ajout objet métier
                            autoHideDelay: 3000,
                            variant: "success",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                        
                        this.visible = false;     
                    })
                    .catch(err => {
                        console.error(err);
                        this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { // Une erreur s'est produite.
                            title: this.$t('Error').toString(), // Erreur
                                autoHideDelay: 10000,
                                variant: "danger",
                                solid: true,
                                appendToast: true,
                                toaster: "b-toaster-top-center"
                            });
                    });
            }
            else {
                // On émet un evenement pour la création d'un nouvel équipement et on ferme cette fenêtre
                this.$emit('CreateNewEquipmentEvent', this.SelectedMenuItem.ObjectType);
                this.visible = false;              
            }
        }
    }
</script>

<style scoped>
    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }
</style>